const axios = require("axios").default;

const URL_BASE = `${process.env.REACT_APP_API_URL}`;

export const getAll = (payload) => {
  return axios
    .get(`${URL_BASE}/user`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getPh3 = (payload) => {
  return axios
    .get(`${URL_BASE}/material-ph3`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getRole = (payload) => {
  return axios
    .get(`${URL_BASE}/role`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const getPlant = (payload) => {
  return axios
    .get(`${URL_BASE}/plant`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getId = (id) => {
  return axios
    .get(`${URL_BASE}/user/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updatePassword = (id, params) => {
  console.log(id);
  console.log(params);
  return axios
    .put(`${URL_BASE}/user/update-password/${id}`, params)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createItem = (payload) => {
  console.log(payload, "payload API");
  return axios.post(`${URL_BASE}/user`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateItem = (payload) => {
  console.log(payload.userId, "payload.userId");
  return axios
    .put(`${URL_BASE}/user/${payload.userId}`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const unlockUser = (payload) => {
  return axios.put(`${URL_BASE}/user/set-lock`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const activeUser = (payload) => {
  return axios.put(`${URL_BASE}/user/set-active`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const postFileExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_BASE}/user-upload`, formData).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
